// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1OftU","row":"ProcedureTreatmentSummary_row__2Ulno"};